/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M15.1107 1.3541a.75.75 0 0 0-.7689.0038L6.8124 5.9034a.75.75 0 0 0-.3624.642v1.3637a.75.75 0 0 0 1.5 0v-.9403l6.7837-4.0953L22.45 7.4282v9.1436l-7.7163 4.5547L7.95 17.0312v-.9403a.75.75 0 0 0-1.5 0v1.3636a.75.75 0 0 0 .3624.6421l7.5294 4.5455a.7501.7501 0 0 0 .7689.0038l8.4706-5A.75.75 0 0 0 23.95 17V7a.75.75 0 0 0-.3687-.6459l-8.4706-5ZM5.0303 8.9697a.75.75 0 0 1 0 1.0606L3.8106 11.25H13a.75.75 0 0 1 0 1.5H3.8106l1.2197 1.2197a.75.75 0 0 1-1.0607 1.0606L.9394 12l3.0304-3.0303a.75.75 0 0 1 1.0606 0Z"
    clipRule="evenodd"
  />,
  'MenuEgress'
);
